import React, { useEffect, useMemo, useRef, useState } from "react";
import DataTable from "../../../components/common/datatable/DataTable";
import ButtonComponent from "../../../components/common/button/Button";
import "../analyticsresults/AnalyticsResults.css";
import TopSection from "../TopSection";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../components/common/Loader";
import { OutBoundTableHeaders } from "./OutBoundTableHeader";
import { getOutboundDataEndpoint, postOutboundResolvedEndpoint, postOutboundResyncEndpoint } from "../../../common/endpoints";
import { getOutboundSyncData } from "../../../redux/actions/Admin/OutboundDataTableSlice";
import { postOutboundResync } from "../../../redux/actions/Admin/OutboundResyncSlice";
import { toast } from "react-toastify";
import { postOutboundResolved } from "../../../redux/actions/Admin/OutboundResolvedSlice";
import OutBoundDataModal from "./OutBoundDataModal";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CreateTicketModal from "./CreateTicketModal";
import NotAllowedModal from "./NotAllowedModal";
import { setSelectedItem } from "../../../redux/actions/SupportTicket/selectionSlice";

const OutBoundDataSync = () => {
    const userEmail = localStorage.getItem("data")
    const userRole = localStorage.getItem("LTRole")
    const dispatch = useDispatch();
    const stateSelector = useSelector((state) => state);
    const [rowData, setRowData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openOutboundModal, setOpenOutboundModal] = useState(false);
    const [openCreateTicket, setOpenCreateTicket] = useState(false);
    const [createTicketData, setCreateTicketData] = useState(false);
    const [viewAllData, setViewAllData] = useState({});
    const [selectedName, setSelectedName] = useState("");

    const [openNotAllowed, setOpenNotAllowed] = useState(false);
    const [notAllowedResponse, setNotAllowedResponse] = useState({});

    const gridRef = useRef();
    const currentPageRef = useRef(0);
    const [gridApi, setGridApi] = useState();

    const [checkedOverrideCoolingPeriod, setCheckedOverrideCoolingPeriod] = useState(false);

    const handleChange = (event) => {
        setCheckedOverrideCoolingPeriod(event.target.checked);
    };

    useEffect(() => {
        getWorkFlowData();
    }, [])

    const getWorkFlowData = async () => {
        try {
            const responseOutbound = await dispatch(getOutboundSyncData({
                dynamicEndpoint: `${getOutboundDataEndpoint}`,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                }
            }));
            if (responseOutbound?.meta?.requestStatus === 'fulfilled') {
                gridApi?.deselectAll();
                setRowData(responseOutbound?.payload);
            } else {
                console.error('Failed to fetch data:', responseOutbound?.error);

            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const pagination = true;
    const paginationPageSize = 10;
    const paginationPageSizeSelector = [10, 20, 30, 50, 100];

    const onGridReady = (params) => {
        setGridApi(params?.api);
        gridRef.current = params?.api;
        setSelectedRows([])
    }

    const onSelectionChanged = (params) => {
        const filteredSelectedRows = [];
        params?.api?.forEachNodeAfterFilter((node) => {
            if (node.isSelected()) {
                filteredSelectedRows.push(node.data);
            }
        });
        setSelectedRows(filteredSelectedRows);
        dispatch(setSelectedItem(filteredSelectedRows));
    }

    const rowSelection = useMemo(() => {
        return {
            mode: 'multiRow',
            isRowSelectable: (rowNode) => rowNode.data.contractUpdateStatus === "Failed" || rowNode.data.mmUpdateStatus === "Failed" || rowNode.data.pirUpdateStatus === "Failed",
        }

    })
    const selectionColumnDef = useMemo(() => ({
        pinned: 'left'
    }))

    const gridOptions = {
        getRowId: (params) => {
            return `${params?.data?.runOutputSeqId}`
        },
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
            sortable: true,
            filter: 'agMultiColumnFilter',
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            suppressMiniFilter: false,
                        },
                    },
                    {
                        filter: 'agSetColumnFilter',
                        filterParams: {
                            excelMode: 'windows',
                            suppressMiniFilter: false,
                            buttons: ['apply', 'reset'],
                        },
                    },
                ],
            },
            autoHeight: true,
            cellStyle: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.5,
                display: "flex",
                alignItems: "center",
            },
            valueGetter: (params) => {
                if (!params.data) return "-";

                const field = params.colDef.field;
                const value = params.data[field];

                return value === null || value === undefined || value === "" ? "-" : value;
            },
        },
    }

    const onClickResyncButton = async () => {
        const arrResync = [];
        selectedRows?.map((item) => {
            arrResync.push(item.outboundIntSeqId)
        })
        const resyncRequestBody = {
            "userEmail": userEmail,
            "outboundIntSeqIds": arrResync,
            "overrideCoolingPeriod": checkedOverrideCoolingPeriod
        }
        try {
            const responseViewAllDetails = await dispatch(postOutboundResync({
                dynamicEndpoint: `${postOutboundResyncEndpoint}`,
                data: resyncRequestBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                },
            }));
            if (responseViewAllDetails?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseViewAllDetails?.payload, {
                    autoClose: 2000,
                });
                setSelectedRows([]);
                setCheckedOverrideCoolingPeriod(false);
                getWorkFlowData();
            } else {
                setCheckedOverrideCoolingPeriod(false);
                toast.error(responseViewAllDetails?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const onClickResolvedButton = async () => {
        const arrResolved = [];
        selectedRows?.map((item) => {
            arrResolved.push(item?.outboundIntSeqId)
        })

        const resolvedRequestBody = {
            "userEmail": userEmail,
            "outboundIntSeqIds": arrResolved
        }
        try {
            const responseResolved = await dispatch(postOutboundResolved({
                dynamicEndpoint: `${postOutboundResolvedEndpoint}`,
                data: resolvedRequestBody,
                params: {
                    plant: localStorage.getItem("selectedLTPlantCode")
                },
            }));
            if (responseResolved?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseResolved?.payload, {
                    autoClose: 2000,
                });
                setSelectedRows([]);
                getWorkFlowData();
            } else {
                toast.error(responseResolved?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }
    const onPaginationChanged = () => {
        if (gridRef.current && !gridRef.current.isDestroyed()) {
            const currentPage = gridRef.current.paginationGetCurrentPage();
            currentPageRef.current = currentPageRef.current || currentPage;
        }
    };
    const onFirstDataRendered = () => {
        if (gridRef.current && !gridRef.current.isDestroyed()) {
            gridRef.current.paginationGoToPage(currentPageRef.current || 0);
        }
    };
    const getRowHeight = (params) => {
        return params.api.getDisplayedRowAtIndex(params.node.rowIndex).rowHeight;
    };
    const handleDownloadData = () => {
        const customHeaders = ['ID', 'Supplier', 'Material', 'Purchasing Document Type', 'Incoterm Location', 'Ship To City', 'Lead Time Variations', 'Recommended LT to be Updated in S/4', 'Final Approved by', 'Approved Timestamp', 'Status', 'Status Updated at', 'S/4 No of Attempts', 'MDG No of Attempts', 'S/4 Error Description', 'MDG Error Description', 'Contract Update', 'PIR Update', 'Material Master Update'];
        const csvRows = [];

        csvRows.push(customHeaders.join(','));
        selectedRows.forEach(row => {
            const rowData = [row.runOutputSeqId, row.supplierId, row.materialId, row.purchasingDocType, row.shipFrom, row.shipTo, row.ltVariations, row.finalLt, row.finalApprovedBy, row.createdAt, row.status, row.modifiedAt, row.s4NoOfAttempts, row.mdgNoOfAttempts, row.s4ErrorMessage, row.mdgErrorMessage, row.contractUpdateStatus, row.pirUpdateStatus, row.mmUpdateStatus].map(value => {
                const stringValue = String(value ?? '');
                const escaped = stringValue.replace(/"/g, '""');
                return `"${escaped}"`;
            });
            csvRows.push(rowData.join(','));
        });

        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'data sync.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleOpenOutboundModal = (row, name) => {
        setOpenOutboundModal(true);
        setViewAllData(row);
        setSelectedName(name)
    }
    const handleCloseOutboundModal = (row) => {
        setOpenOutboundModal(false);
        setViewAllData({});
    }
    const handleOpenCreateTicket = () => {
        setOpenCreateTicket(true);
        setCreateTicketData(selectedRows)
    }
    const handleCloseCreateTicket = () => {
        setOpenCreateTicket(false);
        setCreateTicketData({});
        getWorkFlowData();
    }
    const handleOpenNotAllowed = (row, name) => {
        setOpenNotAllowed(true);
        setNotAllowedResponse(row);
    }
    const handleCloseNotAllowed = (row) => {
        setOpenNotAllowed(false);
        setNotAllowedResponse({});
    }

    const outBoundColumnHeaders = OutBoundTableHeaders(handleOpenOutboundModal, handleOpenNotAllowed, handleOpenCreateTicket);

    return (
        (stateSelector?.OutboundDataTableSlice?.loading || stateSelector?.OutboundResyncSlice.loading || stateSelector?.OutboundResolvedSlice.loading) ?
            <Loader />
            :
            <div>
                <TopSection tabTitle="S/4 Data-Sync Status" labelList={[{ title: 'Home', path: '/landing-page' }, { title: 'S/4 Data-Sync Status' }]} />
                <div
                    style={{
                        border: "1px solid lightgrey",
                        borderRadius: "6px",
                        padding: "10px",
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'end', margin: '5px 0px 10px 0px' }}>
                        <span style={{ fontSize: 14, textDecoration: 'underline', cursor: (selectedRows?.length === 0 || selectedRows?.length === undefined) ? "auto" : 'pointer', color: (selectedRows?.length === 0 || selectedRows?.length === undefined) ? "#bcbcbc" : "#000" }} onClick={() => selectedRows?.length !== 0 && handleDownloadData()}>Download the data for selected line items</span>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <div>
                            {rowData && <DataTable
                                ref={gridRef}
                                columns={outBoundColumnHeaders}
                                rows={rowData || []}
                                paginationProp={pagination}
                                paginationPageSize={paginationPageSize}
                                paginationPageSizeSelector={paginationPageSizeSelector}
                                onGridReady={onGridReady}
                                onSelectionChanged={onSelectionChanged}
                                headerCheckboxSelectionFilterOnly={true}
                                rowSelection={rowSelection}
                                selectionColumnDef={selectionColumnDef}
                                gridOptions={gridOptions}
                                getRowHeight={getRowHeight}
                                onPaginationChanged={onPaginationChanged}
                                onFirstDataRendered={onFirstDataRendered}
                            />}
                        </div>
                    </div>
                    <div>
                        <OutBoundDataModal data={viewAllData} selectedName={selectedName} openOutboundModal={openOutboundModal} handleCloseOutboundModal={handleCloseOutboundModal} />
                    </div>
                    <div>
                        <CreateTicketModal data={selectedRows} openCreateTicket={openCreateTicket} handleCloseCreateTicket={handleCloseCreateTicket} />
                    </div>
                    <div>
                        <NotAllowedModal response={notAllowedResponse} openNotAllowedModal={openNotAllowed} handleCloseNotAllowedModal={handleCloseNotAllowed} />
                    </div>
                </div>
                { userRole !== "Viewer" &&
                <div style={{ margin: '20px 0px', display: 'flex', gap: 10, justifyContent: "space-between", alignItems: 'center' }}>
                    <div>
                        <ButtonComponent
                            maxWidth="200px"
                            label="Create Ticket"
                            type="secondary"
                            onClick={handleOpenCreateTicket}
                            disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined)}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: 10, justifyContent: "space-between", alignItems: 'center' }}>
                        <FormControlLabel disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined)}
                            control={<Checkbox checked={checkedOverrideCoolingPeriod} onChange={handleChange} />}
                            label="Override Cooling Period in S/4"
                        />
                        <ButtonComponent
                            maxWidth="200px"
                            label="Re-sync"
                            type="primary"
                            bgColor="#f53c00"
                            color="white"
                            onClick={onClickResyncButton}
                            disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined)}
                        />
                        <ButtonComponent
                            maxWidth="200px"
                            label="Resolved"
                            type="secondary"
                            onClick={onClickResolvedButton}
                            disabled={(selectedRows?.length === 0 || selectedRows?.length === undefined)}
                        />
                    </div>
                </div> }
            </div>
    );
};

export default OutBoundDataSync;
